{
  "version": "0.1.6",
  "name": "@mastercard/developers-agent-toolkit",
  "homepage": "https://github.com/mastercard/developers-agent-toolkit",
  "description": "Agent Toolkit for Mastercard Developers Platform",
  "author": "Mastercard",
  "license": "MIT",
  "scripts": {
    "build": "tsup",
    "clean": "rm -rf mcp",
    "test": "jest",
    "test:coverage": "jest --coverage",
    "lint": "eslint \"./**/*.ts*\"",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "prepare": "cd .. && husky typescript/.husky"
  },
  "files": [
    "mcp/**/*",
    "LICENSE",
    "README.md",
    "VERSION",
    "package.json"
  ],
  "keywords": [
    "agent-toolkit",
    "mcp",
    "modelcontextprotocol",
    "mastercard",
    "mastercard-developers"
  ],
  "exports": {
    "./mcp": {
      "types": "./mcp/index.d.ts",
      "default": "./mcp/index.js"
    }
  },
  "engines": {
    "node": ">=18"
  },
  "devDependencies": {
    "@eslint/compat": "^1.3.1",
    "@types/jest": "^29.5.14",
    "@types/node-fetch": "^2.6.12",
    "@typescript-eslint/eslint-plugin": "^8.38.0",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-import": "^2.32.0",
    "eslint-plugin-jest": "^28.14.0",
    "eslint-plugin-prettier": "^5.5.3",
    "husky": "^9.1.7",
    "jest": "^29.7.0",
    "lint-staged": "^16.1.2",
    "prettier": "^3.6.2",
    "ts-jest": "^29.2.5",
    "ts-node": "^10.9.2",
    "tsup": "^8.5.0",
    "typescript": "^5.8.3"
  },
  "dependencies": {
    "@modelcontextprotocol/sdk": "^1.27.1",
    "node-fetch": "^2.7.0",
    "zod": "^3.25.67"
  },
  "lint-staged": {
    "*.{mjs,js,jsx,ts,tsx}": [
      "prettier --ignore-unknown --ignore-path .gitignore --write",
      "eslint --cache --cache-strategy content --ext .js,.ts --fix"
    ],
    "*.{yml,json,md,html,css,scss,sass}": [
      "prettier --ignore-unknown --ignore-path .gitignore --write"
    ]
  }
}
